import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { StorageServiceProvider } from '../storage-service/storage-service';

@Injectable()
export class FilterServiceProvider {
  private default = {
    date: "",
    event: "",
    manager: -1,
    order: "ASC",
    region: "",
    sort: "params.sapId",
    lastEventType: "",
    type: "",
    user: -1,
    kpi: 0,
    rankingId: 0,
    regions: 1000,
    placeName: '',
    specialty: '',
    sapId: null,
    segment: '',
    lastEventStatus: '',
    lastEventFrom: '',
    lastEventTo: ''
  };
  private filter = {};

  constructor(private storage: StorageServiceProvider) {
    this.filter[FilterType.CLIENTS] = new BehaviorSubject(this.default);
    this.filter[FilterType.CALENDAR] = new BehaviorSubject(this.default);
  }

  public load(): Promise<any> {
    return Promise.all([
      this.storage.get("clientsFilter"),
      this.storage.get("calendarFilter")
    ])
      .then((filter: any[]) => {
        this.filter[FilterType.CLIENTS].next(filter[0])
        this.filter[FilterType.CALENDAR].next(filter[1])
      })
      .catch(() => {
        this.storage.set("clientsFilter", this.filter[FilterType.CLIENTS].getValue());
        this.storage.set("calendarFilter", this.filter[FilterType.CALENDAR].getValue());
      });
  }

  public getFilter(type: FilterType) {
    return this.filter[type].getValue();
  }

  public subscribe(type: FilterType, callback) {
    return this.filter[type].subscribe(callback);
  }

  public setFilter(type: FilterType, filter): Promise<void> {
    this.filter[type].next(filter);
    return this.storage.set(type.toString() + "filter", { ...filter, searchQuery: '' }).catch();
  }

  public get defaultFilter() {
    return this.default;
  }
}

export enum FilterType {
  CLIENTS = "CLIENTS", CALENDAR = "CALENDAR"
}



// WEBPACK FOOTER //
// ./src/modules/core/services/filter-service/FilterServiceProvider.ts